import { Card, Col, Image, Row, Carousel } from "antd";
import React, { useRef, useEffect } from "react";
import Header from "../header/header";

const awardscard = [
  // {
  //   src: "Sources/images/awards/13.jpg",
  //   title: "ISO 9001:2015",
  //   subtitle: "(Quality Management System)",
  //   des: "",
  // },
  // {
  //   src: "Sources/images/awards/14.jpg",
  //   title: "ISO 45001:2018",
  //   subtitle: "(Occupational Health and Safety Management System)",
  //   des: "",
  // },
  {
    src: "Sources/images/awards/AnubhavSchollProject.png",
    title: "CIDC Vishwakarma Awards 2025 for Anubhav School - Ahmedabad",
    des: "",
  },
  {
    src: "Sources/images/awards/BellagioProject.png",
    title: "CIDC Vishwakarma Awards 2025 for The Bellagio - Ahmedabad",
    des: "",
  },

  {
    src: "Sources/images/awards/AraynyamProject.png",
    title: "CIDC Vishwakarma Awards 2025 for Aranyam - Ahmedabad",
    des: "",
  },
  {
    src: "Sources/images/awards/28.jpg",
    title:
      "Gujarat Nirman Sanman Awards 2025 - Visionary Contractor Achievement",
    des: "",
  },
  {
    src: "Sources/images/awards/Realty_Plus.jpeg",
    title:
      "Construction Firm of the Year by 17th Realty+ Excellence Awards 2025 - Gujarat",
    des: "",
  },
  {
    src: "Sources/images/awards/Realty_Plus.jpeg",
    title:
      "Young Achiever of the Year - Mr. Raj Shah, Director and CFO Hitech Projects Limited.",
    des: "",
  },
  {
    src: "Sources/images/awards/31.jpg",
    title: "14TH QUALITY MARK AWARD - 2025",
    des: "",
  },
  {
    src: "Sources/images/awards/adani_walmer.jpeg",
    title:
      "Honored with the Innovation Award for the Adani Wilmar Project during Quality Week 2025, organized by Adani Realty.",
    des: "",
  },
  // {
  //   src: "Sources/images/awards/33.jpg",
  //   title:
  //     "Excellence & Fasted Growing Construction Company in Ahmedabad 2024 by Built India",
  //   des: "",
  // },
  {
    src: "Sources/images/awards/8.jpg",
    title: "CIDC Vishwakarma Awards 2023 for Venus Pashmina - Ahmedabad",
    des: "",
  },

  {
    src: "Sources/images/awards/Banyan.jpg",
    title:
      "“THE BANYAN” Project was awarded for Outstanding Structure at State Level in Mass Housing category ( < 100) - 2020",
    des: "",
  },
  {
    src: "Sources/images/awards/High Temp.jpg",
    title:
      "“HIGH TEMP FURNACES” was awarded for Outstanding Structure at Regional Level North Gujarat in Industrial category - 2020",
    des: "",
  },
  {
    src: "Sources/images/awards/sunEvoq.jpeg",
    title:
      "“SUN EVOQ” was awarded for Outstanding Structure at Regional Level North Gujarat in Mass Housing category ( < 100) - 2020",
    des: "",
  },
  {
    src: "Sources/images/awards/23.jpg",
    title:
      "Lifting India Safety Awards 2025 for Lifting in High Rise Building Constructions",
    des: "",
  },
  // {
  //   src: "Sources/images/awards/LiftingInHighRise.png",
  //   title: "Lifting in High Rise Building Constructions",
  //   des: "",
  // },

  // {
  //   src: "Sources/images/awards/5.png",
  //   title: "Safety Award",
  //   des: "Received award/certificate from Ahmedabad one mall for achieving 1 lakh safe man hours without LTI",
  // },
  // {
  //   src: "Sources/images/awards/6.png",
  //   title: "Safety Award",
  //   des: "Received award/certificate from CQRA for achieving 1 million safe man hours without LTI at one 49 site",
  // },
  // {
  //   src: "Sources/images/awards/7.jpg",
  //   title: "Safety Award",
  //   des: "The Achievement of One Lakh safe man-hours without lost time injury (LTI)",
  // },

  // {
  //   src: "Sources/images/awards/9.jpg",
  //   title: "Safety Award",
  //   des: "The Achievement of 1 million safe man-hours for their projects ONE49 site",
  // },
  // {
  //   src: "Sources/images/awards/10.jpg",
  //   title: "Safety Award",
  //   des: "The Achievement of Half million safe man-hours for their projects ONE49 site",
  // },
  // {
  //   src: "Sources/images/awards/11.JPG",
  //   title: "Safety Award",
  //   des: "The winning of ICI-UltraTech Outstanding Stucture Awards 2020 (Regional) in the category Industrial Buildings",
  // },
  // {
  //   src: "Sources/images/awards/12.jpg",
  //   title: "Structure Award",
  //   des: "Project “ICI” was awarded for Outstanding Structure Award 2020 at North Gujarat",
  // },

  // {
  //   src: "Sources/images/awards/15.jpg",
  //   title: "Safety Award",
  //   des: "Project “UNICHARM” for Completing 1 Lakh safe man hours sanand site  ",
  // },
  // {
  //   src: "Sources/images/awards/16.JPG",
  //   title: "Structure Award",
  //   des: "The winning of ICI-UltraTech Outstanding Stucture Awards 2020 (Regional) in the category Mass Housing",
  // },
  // {
  //   src: "Sources/images/awards/17.JPG",
  //   title: "Structure Award",
  //   des: "Project “ICI” was awarded for Outstanding Structure Award 2020 in the category Mass housing",
  // },
  // {
  //   src: "Sources/images/awards/18.JPG",
  //   title: "Structure Award",
  //   des: "Project “ICI-UltraTech” was awarded for Outstanding Structure Award 2020 in the category Mass housing",
  // },
  // {
  //   src: "Sources/images/awards/19.jpg",
  //   title: "Structure Award",
  //   des: "Project “ICI-UltraTech” was awarded for Outstanding Structure Award 2020 in the category Mass housing",
  // },
  // {
  //   src: "Sources/images/awards/20.jpg",
  //   title: "CIDC Vishwakarma Award - Construction HSE",
  //   des: "Project “Anubhav School, Ahmedabad” received the 16th CIDC Vishwakarma Award 2025 for excellence in Construction Health, Safety & Environment.",
  // },
  // {
  //   src: "Sources/images/awards/21.jpg",
  //   title: "CIDC Vishwakarma Award - Construction HSE",
  //   des: "Project “The Bellagio, Ahmedabad” was honoured with the 16th CIDC Vishwakarma Award 2025 for outstanding Construction Health, Safety & Environment practices.",
  // },
  // {
  //   src: "Sources/images/awards/22.jpg",
  //   title: "CIDC Vishwakarma Award - Construction HSE",
  //   des: "Project “Aranyam, Ahmedabad” received the 16th CIDC Vishwakarma Award 2025 recognising its commitment to Construction Health, Safety & Environment.",
  // },

  // {
  //   src: "Sources/images/awards/24.jpeg",
  //   title: "Quality Mark Award 2025",
  //   des: "Declared as a winner at the 14th Quality Mark Awards 2025 for excellence in Integrated Project Management & Construction practices.",
  // },
  // {
  //   src: "Sources/images/awards/25.jpeg",
  //   title: "Gujarat Nirman Sanman Award 2025",
  //   des: "Recognised under the Visionary Contractor Achievement Awards (B2B) for excellence and innovation in urban residential construction.",
  // },
  // {
  //   src: "Sources/images/awards/26.png",
  //   title: "Realty+ Conclave & Excellence Award 2025",
  //   des: "Honoured at the 17th edition in Gujarat for outstanding performance in the real estate and construction industry.",
  // },
  // {
  //   src: "Sources/images/awards/27.png",
  //   title: "Realty+ Conclave & Excellence Awards 2025",
  //   des: "Recognised for outstanding contribution to the real estate and construction sector in Gujarat.",
  // },
];

const Awards = () => {
  const carouselRef = useRef(null);

  const sliderImages = [
    "Sources/images/awards/slider1.jpeg",
    "Sources/images/awards/slider2.jpeg",
    "Sources/images/awards/slider3.jpeg",
    "Sources/images/awards/slider4.jpeg",
    "Sources/images/awards/slider5.jpeg",
    "Sources/images/awards/slider6.jpeg",
    "Sources/images/awards/slider7.jpeg",
    "Sources/images/awards/slider8.jpeg",
  ];

  useEffect(() => {
    // Prevent carousel from pausing on hover
    const preventPause = () => {
      if (carouselRef.current?.innerSlider) {
        const slider = carouselRef.current.innerSlider;
        if (slider && typeof slider.pause === "function") {
          // Store original pause if not already stored
          if (!slider._originalPause) {
            slider._originalPause = slider.pause;
          }
          // Override pause to do nothing
          slider.pause = () => {};
        }
      }
    };

    // Check immediately and also on a small delay to ensure carousel is initialized
    preventPause();
    const timeout = setTimeout(preventPause, 100);

    return () => {
      clearTimeout(timeout);
      // Restore original pause on cleanup
      if (carouselRef.current?.innerSlider?._originalPause) {
        carouselRef.current.innerSlider.pause =
          carouselRef.current.innerSlider._originalPause;
      }
    };
  }, []);

  return (
    <>
      <img
        src="Sources/images/awards/awards.JPG"
        alt="404 -Not Given"
        className="about_img"
        //style={{ marginLeft: window.innerWidth > 1355 ? "5%" : "" }}
      />

      <div className="about-us-bg">
        {/* <Header /> */}
        <section>
          <div className="section_padding"></div>
          <div className="container">
            <div>
              <p style={{color: '#0d2e61'}} className="is-size-2 has-text-weight-semibold has-text-centered  mb-5">
                Awards And Certifications
              </p>
              {/* <p className="is-size-4 has-text-centered mb-3">Year 2020</p> */}
              <p className="is-size-5 has-text-centered mt-3">
                {/* Our company has been felicitated with the Indian Concrete
              Institute-Ultra Tech Outstanding Structure Awards 2020 at State
              And Regional Level. */}
                The many talented and devoted workers at Hitech are responsible
                for the numerous awards and recognition <br />
                we have received throughout the years.
              </p>
            </div>
            <div
              className="awards-carousel-wrapper"
              style={{ marginBottom: "3rem", position: "relative" }}
            >
              <style>
                {`
                  .awards-carousel-wrapper .ant-carousel {
                    position: relative;
                  }
                  .awards-carousel-wrapper .ant-carousel .slick-dots {
                    position: absolute !important;
                    bottom: 15px !important;
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                    width: auto !important;
                    text-align: center !important;
                    margin: 0 !important;
                    padding: 0 !important;
                  }
                  .awards-carousel-wrapper .ant-carousel .slick-dots li {
                    margin: 0 4px !important;
                  }
                  .awards-carousel-wrapper .ant-carousel .slick-dots li button {
                    width: 10px !important;
                    height: 10px !important;
                    border-radius: 50% !important;
                    box-shadow: none !important;
                    text-shadow: none !important;
                  }
                  .awards-carousel-wrapper .ant-carousel .slick-dots li button::before,
                  .awards-carousel-wrapper .ant-carousel .slick-dots li button::after {
                    display: none !important;
                  }
                `}
              </style>
              <button
                onClick={() => carouselRef.current?.prev()}
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  background: "rgba(0, 0, 0, 0.5)",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "28px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: "1",
                  padding: "0",
                  paddingBottom: "2px",
                }}
              >
                ‹
              </button>
              <button
                onClick={() => carouselRef.current?.next()}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  background: "rgba(0, 0, 0, 0.5)",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "28px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: "1",
                  padding: "0",
                  paddingBottom: "2px",
                }}
              >
                ›
              </button>
              <Carousel
                ref={carouselRef}
                autoplay
                autoplaySpeed={2000}
                style={{ maxWidth: "100%" }}
                dotPosition="bottom"
              >
                {sliderImages.map((src, index) => (
                  <div key={index}>
                    <img
                      src={src}
                      alt={`Award ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </div>
                ))}
              </Carousel>
            </div>
            <div>
              <Row style={{ display: "flex", justifyContent: "center" }}>
                {awardscard.map((item, key) => {
                  return (
                    <Col
                      xxl={8}
                      lg={8}
                      md={12}
                      sm={24}
                      xs={24}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Card className="awardcard">
                        <div className="has-text-centered service_icon">
                          <div>
                            <Image
                              preview={{
                                getContainer: "#root", // This ensures the image preview is rendered within the root element
                              }}
                              src={item.src}
                              alt="404 - Not Found"
                              style={{ height: "25vh", width: "100%" }}
                            />
                          </div>
                        </div>
                        <div>
                          <p style={{color: '#0d2e61'}} className="is-size-5 has-text-weight-semibold has-text-centered mt-4 ">
                            {item.title}
                            {item.subtitle && (
                              <>
                                <br />
                                <span style={{ fontSize: "0.9em" }}>
                                  {item.subtitle}
                                </span>
                              </>
                            )}
                          </p>
                          <p className="is-size-5 has-text-left mt-4">
                            {item.des}
                          </p>
                        </div>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </div>
          <div className="section_padding"></div>
        </section>
      </div>
    </>
  );
};

export default Awards;
